import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import * as RadixSelect from "@radix-ui/react-select";
import { forwardRef } from "react";
export const SelectContent = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { children, className, position = "popper", sideOffset = 8, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(RadixSelect.Portal, {
        children: /*#__PURE__*/ _jsx(RadixSelect.Content, {
            className: tailwindMerge("relative z-portal flex max-h-[--radix-select-content-available-height] w-full min-w-[var(--radix-select-trigger-width)] flex-col gap-2 overflow-hidden rounded-4 bg-surface-1 p-2 text-grey-12 shadow-popover outline-none radix-side-bottom:animate-slide-up radix-side-top:animate-slide-down dark:border dark:border-grey-5", className),
            "data-testid": "SELECT_CONTENT",
            position: position,
            sideOffset: sideOffset,
            ...restOfProps,
            ref: forwardedRef,
            children: /*#__PURE__*/ _jsx(RadixSelect.Viewport, {
                children: children
            })
        })
    });
});
SelectContent.displayName = "SelectContent";
